/* eslint-disable max-len */
import { useState, useEffect } from "react";
import NamurType from "../constants/NamurType";

// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/ok.svg' or it... Remove this comment to see the full error message
import Ok from "../assets/images/ok.svg";

// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/failure.svg' ... Remove this comment to see the full error message
import Failure from "../assets/images/failure.svg";
// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/check-functio... Remove this comment to see the full error message
import CheckFunction from "../assets/images/check-function.svg";
// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/maintenance-r... Remove this comment to see the full error message
import MaintenanceRequired from "../assets/images/maintenance-required.svg";
// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/out-of-specif... Remove this comment to see the full error message
import OutOfSpecification from "../assets/images/out-of-specification.svg";
// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/unknown.svg' ... Remove this comment to see the full error message
import Unknown from "../assets/images/unknown.svg";
// @ts-expect-error TS(2307) FIXME: Cannot find module '../assets/images/undefined.svg... Remove this comment to see the full error message
import Undefined from "../assets/images/undefined.svg";

type OwnProps = {
  type?: string;
  size?: number;
  mobileSize?: number;
};

const defaultProps: Partial<OwnProps> = {
  type: undefined,
  size: 32,
  mobileSize: undefined,
};

type Props = OwnProps & typeof defaultProps;

function NamurIcon({ type, size, mobileSize }: Props) {
  /* eslint-disable no-nested-ternary */
  const calculateSize = () =>
    mobileSize ? (window.innerWidth >= 768 ? size : mobileSize) : size;
  const [calculatedSize, setCalculatedSize] = useState(calculateSize());

  useEffect(() => {
    const handleResize = () => setCalculatedSize(calculateSize());
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const secondSize = Math.round(calculatedSize * 0.8);
  const style = {
    position: "relative",
    textAlign: "center",
    display: "inline-block",
  };
  switch (type) {
    case NamurType.OK:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <Ok
            width={secondSize}
            height={secondSize}
            viewBox="0 0 56 56"
            data-testid="Namur-OK"
          />
        </div>
      );
    case NamurType.FAILURE:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <Failure
            width={secondSize}
            height={secondSize}
            viewBox="0 0 56 56"
            data-testid="Namur-Failure"
          />
        </div>
      );
    case NamurType.CHECK_FUNCTION:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <CheckFunction
            width={calculatedSize}
            height={calculatedSize}
            viewBox="0 0 68 60"
            data-testid="Namur-CheckFunction"
          />
        </div>
      );
    case NamurType.OUT_OF_SPECIFICATION:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <OutOfSpecification
            width={calculatedSize}
            height={calculatedSize}
            viewBox="0 0 68 60"
            data-testid="Namur-OOS"
          />
        </div>
      );
    case NamurType.MAINTENANCE_REQUIRED:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <MaintenanceRequired
            width={calculatedSize}
            height={calculatedSize}
            viewBox="0 0 60 60"
            data-testid="Namur-Maintenance"
          />
        </div>
      );
    case NamurType.UNKNOWN:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <Unknown
            width={secondSize}
            height={secondSize}
            viewBox="0 0 52 52"
            data-testid="Namur-Unknown"
          />
        </div>
      );
    default:
      return (
        // @ts-expect-error TS(2322) FIXME: Type '{ position: string; textAlign: string; displ... Remove this comment to see the full error message
        <div style={style}>
          <Undefined
            width={calculatedSize}
            height={calculatedSize}
            viewBox="0 0 68 60"
            data-testid="Namur-Undefined"
          />
        </div>
      );
  }
}

NamurIcon.defaultProps = defaultProps;

export default NamurIcon;
